export default {
  'app.settings.menuMap.basic': 'Основные настройки',
  'app.settings.menuMap.security': 'Настройки безопасности',
  'app.settings.menuMap.binding': 'Привязка аккаунта',
  'app.settings.menuMap.notification': 'Уведомления о сообщениях',
  'app.settings.basic.avatar': 'Аватар',
  'app.settings.basic.change-avatar': 'Сменить аватар',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Пожалуйста, введите ваш email!',
  'app.settings.basic.nickname': 'Псевдоним',
  'app.settings.basic.nickname-message': 'Пожалуйста, введите ваш псевдоним!',
  'app.settings.basic.profile': 'Личный профиль',
  'app.settings.basic.profile-message': 'Пожалуйста, введите ваш профиль!',
  'app.settings.basic.profile-placeholder': 'Краткая информация о себе',
  'app.settings.basic.country': 'Страна/Регион',
  'app.settings.basic.country-message': 'Пожалуйста, введите вашу страну!',
  'app.settings.basic.geographic': 'Область или город',
  'app.settings.basic.geographic-message': 'Пожалуйста, введите ваш регион!',
  'app.settings.basic.address': 'Адрес',
  'app.settings.basic.address-message': 'Пожалуйста, введите ваш адрес!',
  'app.settings.basic.phone': 'Номер телефона',
  'app.settings.basic.phone-message': 'Пожалуйста, введите ваш телефон!',
  'app.settings.basic.update': 'Обновить информацию',
  'app.settings.security.strong': 'Надёжный',
  'app.settings.security.medium': 'Средний',
  'app.settings.security.weak': 'Слабый',
  'app.settings.security.password': 'Пароль аккаунта',
  'app.settings.security.password-description': 'Надёжность текущего пароля',
  'app.settings.security.phone': 'Телефон безопасности',
  'app.settings.security.phone-description': 'Привязанный телефон',
  'app.settings.security.question': 'Секретный вопрос',
  'app.settings.security.question-description':
    'Секретный вопрос не задан. Политика безопасности может эффективно защитить аккаунт',
  'app.settings.security.email': 'Резервный Email',
  'app.settings.security.email-description': 'Привязанный Email',
  'app.settings.security.mfa': 'Устройство MFA',
  'app.settings.security.mfa-description':
    'Устройство MFA не привязано. После привязки потребуется двойное подтверждение',
  'app.settings.security.modify': 'Изменить',
  'app.settings.security.set': 'Установить',
  'app.settings.security.bind': 'Привязать',
  'app.settings.binding.taobao': 'Привязка Taobao',
  'app.settings.binding.taobao-description': 'Аккаунт Taobao не привязан',
  'app.settings.binding.alipay': 'Привязка Alipay',
  'app.settings.binding.alipay-description': 'Аккаунт Alipay не привязан',
  'app.settings.binding.dingding': 'Привязка DingTalk',
  'app.settings.binding.dingding-description': 'Аккаунт DingTalk не привязан',
  'app.settings.binding.bind': 'Привязать',
  'app.settings.notification.password': 'Пароль аккаунта',
  'app.settings.notification.password-description':
    'Уведомления от других пользователей в виде сообщений',
  'app.settings.notification.messages': 'Системные сообщения',
  'app.settings.notification.messages-description':
    'Системные уведомления в виде сообщений',
  'app.settings.notification.todo': 'Уведомления задач',
  'app.settings.notification.todo-description':
    'Уведомления списка задач',
  'app.settings.open': 'Включено',
  'app.settings.close': 'Выключено',
};
